import { Dispatch, SetStateAction } from 'react'

import {
  collection,
  CollectionReference,
  deleteDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  Query,
} from 'firebase/firestore'

import { NewLog } from '../../types'
import { firestore } from '../firebaseConfig'

export const subscribeToCollection = <T,>(
  collectionNameRef: CollectionReference | Query,
  setData: (data: T[]) => void,
  setError?: Dispatch<SetStateAction<string | null>>,
  // TODO: add
  // setLoading?: Dispatch<SetStateAction<boolean>>,
) => {
  const unsubscribe = onSnapshot(
    collectionNameRef, //collection(firestore, collectionName),
    (querySnapshot) => {
      const data = querySnapshot.docs.map((doc) => doc.data() as T)
      setData(data)
      // TODO: add
      // setError?.(null)
      // setLoading?.(false)
    },
    (error) => {
      console.log(`Error en la suscripción a la colección:`, error)
      // TODO: replace with
      // setError?.('Hubo un problema al cargar la información.')
      // setLoading?.(false)
      setError && setError('Hubo un error')
    },
  )

  return unsubscribe
}

export const subscribeToLogsOrderedByDate = (
  studentId: string,
  setStudentLogs: Dispatch<SetStateAction<NewLog[] | null>>,
  setStudentError: Dispatch<SetStateAction<string | null>>,
) => {
  const logsCollectionRef = collection(firestore, 'students', studentId, 'logs')

  const q = query(logsCollectionRef, orderBy('date', 'desc'))

  const unsubscribeLogs = subscribeToCollection<NewLog>(
    q,
    setStudentLogs,
    setStudentError,
  )

  return () => unsubscribeLogs()
}

export const deleteCollection = async (collectionRef: CollectionReference) => {
  const querySnapshot = await getDocs(collectionRef)

  const deletePromises = querySnapshot.docs.map((doc) => {
    return deleteDoc(doc.ref)
  })

  await Promise.all(deletePromises)
}
